import styles from "./index.module.scss";
import parse from "html-react-parser";
import { useEffect, useState } from "react";

export default function OnnVideo({
  id,
  videoType,
  description,
  podcast,
}: {
  id: string;
  videoType: string;
  description: string;
  podcast?: string;
}): JSX.Element {
  const [onnId, setRandomId] = useState<string>("");
  const src = `https://video.onnetwork.tv/embed.php?${videoType}=${id}&cId=${onnId}&ap=0&mploff=1`;
  let headingText = "Zobacz wideo";

  useEffect(() => {
    setRandomId(`onn-cid-${Math.floor(Math.random() * 9999999) + 1}`);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.setAttribute("src", src);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [onnId]);

  if (podcast === "true") {
    headingText = "Posłuchaj podcastu";
  }

  return (
    <>
      {onnId && (
        <>
          <div>
            <span className={styles.onnVideoEmbed__heading}>{headingText}</span>
            {description && <span className={styles.onnVideoEmbed__description}>{parse(description)}</span>}
          </div>
          <div id={onnId}></div>
        </>
      )}
    </>
  );
}
